export const navigation = [
  {
    id: 'features',
    title: 'Features',
    type: 'group',
    children: [
      {
        id: 'home',
        title: 'Dashboard ',
        type: 'item',
        icon: 'home',
        url: '/dashboard',
      },
      {
        id: 'subjects',
        title: 'Subjects',
        type: 'collapse',
        icon: 'party_mode',
        url: '/subjects',
        children: [],
      },
      {
        id: 'tasks',
        title: 'Tasks',
        type: 'collapse',
        // icon: 'task_alt',
        icon: 'check_box',
        children: [
          {
            id: 'my-tasks',
            title: 'My Tasks',
            type: 'item',
            // icon: 'check_box',
            url: '/tasks/my',
            badge: {
              title: 3,
              bg: '#d32f2f',
              fg: '#FFFFFF',
            },
          },
          {
            id: 'all-tasks',
            title: 'All Tasks',
            type: 'item',
            // icon: 'check_box',
            url: '/tasks/all',
            badge: {
              title: 3,
              bg: '#d32f2f',
              fg: '#FFFFFF',
            },
          },
        ],
      },
      {
        id: 'processes',
        title: 'Processes',
        type: '',
        icon: 'donut_large',
        url: '/other',
        children: [],
      },
      {
        id: 'referrals',
        title: 'Referrals',
        type: 'collapse',
        icon: 'thumbs_up_down',
        children: [
          {
            id: 'my-referrals',
            title: 'My Referrals',
            type: 'item',
            url: '/referrals/referrals/u/my',
          },
          {
            id: 'list-referrals',
            title: 'All Referrals',
            type: 'item',
            url: '/referrals/referrals/all',
          },
          {
            id: `archived-referrals`,
            title: 'Archived Referrals',
            type: 'item',
            url: `/referrals/referrals/archived`,
            exactMatch: true,
          },
          {
            id: `referrals-duefordeletion`,
            title: 'Referrals Due For Deletion',
            type: 'item',
            url: `/referrals/referrals/duefordeletion`,
            exactMatch: true,
          },
        ],
      },
      {
        id: 'systemMaintenance',
        title: 'System Maintenance',
        type: 'collapse',
        icon: 'build',
        url: '/systemMaintenance',
        children: [
          {
            id: 'assessments',
            title: 'Assessments',
            type: 'collapse',
            children: [
              {
                id: 'assessmentcategories',
                title: 'Categories',
                type: 'item',
                url: '/system-maintenance/assessment-categories',
              },
              {
                id: 'assessmenttemplates',
                title: 'Templates',
                type: 'item',
                url: '/system-maintenance/assessment-templates',
              },
              {
                id: 'assessmenttypes',
                title: 'Types',
                type: 'item',
                url: '/system-maintenance/assessment-types',
              },
            ],
          },
          {
            id: 'audit',
            title: 'Audit Trail',
            type: 'item',
            url: '/system-maintenance/audits',
          },
          {
            id: 'categories',
            title: 'Categories',
            type: 'item',
            url: '/system-maintenance/categories',
          },
          {
            id: 'emailtemplates',
            title: 'Email Templates',
            type: 'item',
            url: '/system-maintenance/emailtemplates',
          },
          {
            id: 'evidenceupload',
            title: 'Evidence Upload',
            type: 'item',
            url: '/system-maintenance/evidenceupload',
          },
          {
            id: 'lookups',
            title: 'Lookups',
            type: 'item',
            url: '/system-maintenance/lookups',
          },
          {
            id: 'lookup-types',
            title: 'Lookup Types',
            type: 'item',
            url: '/system-maintenance/lookup-types',
          },
          {
            id: 'markers',
            title: 'Markers',
            type: 'item',
            url: '/system-maintenance/markers',
          },
          {
            id: 'foinonworkingdays',
            title: 'Non-Working Days',
            type: 'item',
            url: '/system-maintenance/foinonworkingdays',
          },
          {
            id: 'noteTypes',
            title: 'Note Types',
            type: 'item',
            url: '/system-maintenance/note-types',
          },
          {
            id: 'onlinereporting',
            title: 'Online Reporting',
            type: 'item',
            url: '/system-maintenance/onlinereporting',
          },
          {
            id: 'self-manage-organisations',
            title: 'Organisations',
            type: 'item',
            url: '/intec-admin/organisations',
          },
          {
            id: 'process_types',
            title: 'Process Types',
            type: 'item',
            url: '/system-maintenance/process-types',
          },
          {
            id: 'referralsources',
            title: 'Referral Sources',
            type: 'item',
            url: '/system-maintenance/referral-sources',
          },
          {
            id: 'relationships',
            title: 'Relationships',
            type: 'item',
            url: '/system-maintenance/relationships',
          },
          {
            id: 'retentionsettings',
            title: 'Retention Periods',
            type: 'item',
            url: '/system-maintenance/retention-settings',
          },
          {
            id: 'states',
            title: 'States',
            type: 'item',
            url: '/system-maintenance/states',
          },
          {
            id: 'statuses',
            title: 'Statuses',
            type: 'item',
            url: '/system-maintenance/statuses',
          },
          {
            id: 'subjectalerts',
            title: 'Subject Alerts',
            type: 'item',
            url: '/system-maintenance/subjectalerts',
          },
          {
            id: 'subjecttypes',
            title: 'Subject Types',
            type: 'collapse',
            children: [
              {
                id: 'subjecttypedetails',
                title: 'Details',
                type: 'item',
                url: '/system-maintenance/subject-types',
              },
              {
                id: 'layouts',
                title: 'Layouts',
                type: 'item',
                url: '/system-maintenance/layouts',
              },
              {
                id: 'subjectsettings',
                title: 'Settings',
                type: 'item',
                url: '/system-maintenance/subject-settings',
              },
            ],
          },
          {
            id: 'systemsettings',
            title: 'System Settings',
            type: 'item',
            url: '/system-maintenance/system-settings',
          },
          {
            id: 'task_types',
            title: 'Task Types',
            type: 'item',
            url: '/system-maintenance/task-types',
          },
          {
            id: 'user_management',
            title: 'User Management',
            type: 'item',
            url: '/system-maintenance/user-management',
          },
          // {
          //   id: 'workflows',
          //   title: 'Workflows',
          //   type: 'item',
          //   url: '/system-maintenance/workflows',
          // },
        ],
      },
      {
        id: 'subject_alert_import',
        title: 'Subject Alert Import',
        type: 'item',
        icon: 'upload_file',
        url: '/import/saimport',
      },
      {
        id: 'markersearch',
        title: 'Marker Search',
        type: 'collapse',
        icon: 'search',
        url: '/markersearch',
        children: [
          {
            id: 'markersearch_search',
            title: 'Search',
            type: 'item',
            url: '/marker-search/search',
          },
          {
            id: 'markersearch_referral',
            title: 'Add Referral',
            type: 'item',
            url: '/marker-search/referral',
          },
        ],
      },
      {
        id: 'import',
        title: 'Import',
        type: 'item',
        icon: 'upload',
        url: '/import',
      },
      {
        id: 'importgroup',
        title: 'Import',
        type: 'collapse',
        icon: 'upload',
        url: '/import',
        children: [
          {
            id: 'subject_import',
            title: 'Import',
            type: 'item',
            url: '/import/subjects',
          },
          {
            id: 'file_import',
            title: 'File Import',
            type: 'item',
            url: '/import/files',
          },
        ],
      },
      {
        id: 'reportgroup',
        title: 'Reporting',
        type: 'collapse',
        icon: 'bar_chart',
        url: '/reporting',
        children: [
          {
            id: 'referralreports',
            title: 'Referral Reports',
            type: 'item',
            url: '/referralreports',
          },
          {
            id: 'reports',
            title: 'System Reports',
            type: 'item',
            url: '/reports',
          },
          {
            id: 'reportdesigner',
            title: 'Report Designer',
            type: 'item',
            url: '/reportdesigner',
          },
          {
            id: 'reportextract',
            title: 'Report Extract',
            type: 'item',
            url: '/reportextract',
          },
          {
            id: 'reportdashboard',
            title: 'Report Dashboard',
            type: 'item',
            url: '/reportdashboard',
          },
        ],
      },
      {
        id: 'intecAdmin',
        title: 'Intec Admin',
        type: 'collapse',
        icon: 'settings',
        url: '/intecAdmin',
        children: [
          {
            id: 'tenantSettings',
            title: 'Customer Settings',
            type: 'item',
            url: '/intec-admin/customer-settings',
          },
          {
            id: 'organisations',
            title: 'Organisations',
            type: 'item',
            url: '/intec-admin/organisations',
          },
          {
            id: 'workflows',
            title: 'Workflows',
            type: 'item',
            url: '/system-maintenance/workflows',
          },
          {
            id: 'dataExtract',
            title: 'Data Extract',
            type: 'item',
            url: '/intec-admin/data-extract',
          },
          {
            id: 'feedbackSettings',
            title: 'Feedback Settings',
            type: 'item',
            url: '/intec-admin/feedback-settings',
          },
        ],
      },
      // {
      //   id: 'help',
      //   title: 'Help',
      //   type: 'item',
      //   icon: 'help',
      //   url: '/help',
      // },
    ],
  },
];
